<!-- 开通渠道服务客服弹窗 -->
<template>
    <el-dialog title="开通提示" class="openDialog" :visible.sync="dialogTableVisible">
        <div class="content">
            <div class="tips">您当前还未开通渠道功能</div>
            <div class="tips">如需开通请拨打电话<span>0755-86393160</span>或关注公众号联系客服</div>
            <div class="service">
                <img :src="prCodeUrlCC" alt="">
                <p>微信扫码关注公众号</p>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialogTableVisible: false,
            prCodeUrlCC: 'http://img.capwhale.com/zjffh.jpg'
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        open() {
            this.dialogTableVisible = true
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .openDialog {
        .el-dialog__body {
            padding-bottom: 45px;
        }
        .content {
            .tips {
                text-align: center;
                font-size: 16px;
                color: #303133;
                line-height: 28px;
                span {
                    color: #409EFF;
                }
            }
            .service {
                text-align: center;
                padding-top: 15px;
                font-size: 16px;
            }
        }
    }
</style>
